(() => {
  const createSvg = (className, paths) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('class', className);
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    paths.forEach((pathData) => {
      const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      path.setAttribute('d', pathData);
      svg.appendChild(path);
    });

    return svg;
  };

  const appendTocButtonIcons = (button) => {
    button.append(
      createSvg('pra-toc-icon pra-toc-icon--index', [
        'M4.5 5.5c1.9-.9 4.1-.9 6 0 1 .5 2 .5 3 0 1.9-.9 4.1-.9 6 0v13c-1.9-.9-4.1-.9-6 0-1 .5-2 .5-3 0-1.9-.9-4.1-.9-6 0z',
        'M12 5v14',
        'M7.2 8.5h1.6',
        'M7.2 11.5h1.6',
        'M15.2 8.5h1.6',
        'M15.2 11.5h1.6'
      ]),
      createSvg('pra-toc-icon pra-toc-icon--close', ['M6 6l12 12', 'M18 6L6 18'])
    );
  };

  const buildDocumentToc = (page) => {
    if (!page || page.dataset.praDocumentReady === 'true') return;

    const content = page.querySelector('[data-pra-document-content]');
    const aside = page.querySelector('[data-pra-document-aside]');
    const toc = page.querySelector('[data-pra-document-toc]');
    const tocBlock = page.querySelector('[data-pra-document-toc-block]');
    const layout = page.querySelector('.pra-document-page__layout');

    page.dataset.praDocumentReady = 'true';

    if (!content || !toc || !tocBlock || !layout) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => {
      return heading.textContent.trim().length > 0;
    });

    if (!headings.length) {
      page.classList.add('pra-document-page--no-toc');
      tocBlock.hidden = true;
      if (aside) aside.hidden = true;
      return;
    }

    page.classList.remove('pra-document-page--no-toc');
    toc.innerHTML = '';
    if (aside) aside.hidden = false;
    tocBlock.hidden = false;

    const label = tocBlock.querySelector('.pra-document-page__aside-label');
    const desktopLabel = label?.textContent.trim() || 'Nesta pagina';
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const syncLabel = () => {
      if (!label) return;

      label.textContent = mobileQuery.matches ? '\u00CDndice' : desktopLabel;
    };

    syncLabel();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncLabel);
    } else {
      mobileQuery.addListener(syncLabel);
    }

    const navId = toc.id || `pra-document-toc-${document.querySelectorAll('[data-pra-document-toc]').length}`;
    toc.id = navId;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'pra-document-page__toc-toggle';
    toggle.setAttribute('aria-controls', navId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Abrir navegacao desta pagina');
    appendTocButtonIcons(toggle);

    const scrim = document.createElement('button');
    scrim.type = 'button';
    scrim.className = 'pra-document-page__toc-scrim';
    scrim.setAttribute('aria-label', 'Fechar navegacao desta pagina');

    tocBlock.prepend(toggle);
    layout.prepend(scrim);

    const links = [];
    const linksByHeadingId = new Map();

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `pra-page-section-${index + 1}`;
      }

      const link = document.createElement('a');
      link.className = `pra-document-page__toc-link pra-document-page__toc-link--${heading.tagName.toLowerCase()}`;
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      links.push(link);
      linksByHeadingId.set(heading.id, link);
      toc.appendChild(link);
    });

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const syncMobileTocTop = () => {
      const header = document.querySelector('.section-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 137;
      page.style.setProperty('--pra-document-mobile-toc-top', `${Math.max(12, Math.round(headerBottom + 8))}px`);
    };
    const setExpanded = (expanded) => {
      if (expanded && isMobile()) syncMobileTocTop();
      page.classList.toggle('is-document-toc-open', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        expanded ? 'Fechar navegacao desta pagina' : 'Abrir navegacao desta pagina'
      );
    };

    toggle.addEventListener('click', () => {
      if (!isMobile()) return;

      setExpanded(!page.classList.contains('is-document-toc-open'));
    });

    scrim.addEventListener('click', () => setExpanded(false));

    toc.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target.parentElement;

      if (isMobile() && target?.closest('a')) {
        setExpanded(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setExpanded(false);
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) {
        setExpanded(false);
      } else if (page.classList.contains('is-document-toc-open')) {
        syncMobileTocTop();
      }
    });

    const menuDrawer = document.getElementById('Details-menu-drawer-container');
    menuDrawer?.addEventListener('toggle', () => {
      if (menuDrawer.open) setExpanded(false);
    });

    const setActiveLink = (activeLink) => {
      links.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('pra-document-page__toc-link--active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    let activeFrame = null;
    const syncActiveLink = () => {
      activeFrame = null;

      const currentHeading =
        headings
          .filter((heading) => heading.getBoundingClientRect().top <= window.innerHeight * 0.36)
          .pop() || headings[0];
      const activeLink = linksByHeadingId.get(currentHeading.id);

      if (activeLink) setActiveLink(activeLink);
    };

    const scheduleActiveLinkSync = () => {
      if (activeFrame) return;

      activeFrame = requestAnimationFrame(syncActiveLink);
    };

    window.addEventListener('scroll', scheduleActiveLinkSync, { passive: true });
    window.addEventListener('resize', scheduleActiveLinkSync);
    syncActiveLink();
  };

  const initDocumentPages = () => {
    document.querySelectorAll('[data-pra-document-page]').forEach(buildDocumentToc);
  };

  const buildPolicyToc = (container) => {
    if (!container || container.dataset.praPolicyReady === 'true') return;

    const body = container.querySelector('.shopify-policy__body');
    const content = body?.querySelector('.rte');

    container.dataset.praPolicyReady = 'true';

    if (!body || !content) return;

    const headings = Array.from(content.querySelectorAll('h2, h3')).filter((heading) => {
      return heading.textContent.trim().length > 0;
    });

    if (!headings.length) {
      body.classList.add('shopify-policy__body--no-toc');
      return;
    }

    const aside = document.createElement('aside');
    aside.className = 'pra-policy-toc';

    const navId = `pra-policy-toc-${document.querySelectorAll('.pra-policy-toc').length + 1}`;

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'pra-policy-toc__toggle';
    toggle.setAttribute('aria-controls', navId);
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Abrir navegacao desta pagina');
    appendTocButtonIcons(toggle);

    const label = document.createElement('p');
    label.className = 'pra-policy-toc__label';
    label.textContent = 'Nesta pagina';
    const desktopLabel = label.textContent;
    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const syncLabel = () => {
      label.textContent = mobileQuery.matches ? '\u00CDndice' : desktopLabel;
    };

    syncLabel();

    if (mobileQuery.addEventListener) {
      mobileQuery.addEventListener('change', syncLabel);
    } else {
      mobileQuery.addListener(syncLabel);
    }

    aside.appendChild(toggle);
    aside.appendChild(label);

    const nav = document.createElement('nav');
    nav.id = navId;
    nav.className = 'pra-policy-toc__nav';
    nav.setAttribute('aria-label', 'Nesta pagina');

    const links = [];
    const linksByHeadingId = new Map();

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = `pra-policy-section-${index + 1}`;
      }

      const link = document.createElement('a');
      link.className = `pra-policy-toc__link pra-policy-toc__link--${heading.tagName.toLowerCase()}`;
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      links.push(link);
      linksByHeadingId.set(heading.id, link);
      nav.appendChild(link);
    });

    aside.appendChild(nav);

    const scrim = document.createElement('button');
    scrim.type = 'button';
    scrim.className = 'pra-policy-toc__scrim';
    scrim.setAttribute('aria-label', 'Fechar navegacao desta pagina');

    const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
    const setExpanded = (expanded) => {
      body.classList.toggle('is-policy-toc-open', expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.setAttribute(
        'aria-label',
        expanded ? 'Fechar navegacao desta pagina' : 'Abrir navegacao desta pagina'
      );
    };

    toggle.addEventListener('click', () => {
      if (!isMobile()) return;

      setExpanded(!body.classList.contains('is-policy-toc-open'));
    });

    scrim.addEventListener('click', () => setExpanded(false));

    nav.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : event.target.parentElement;

      if (isMobile() && target?.closest('a')) {
        setExpanded(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setExpanded(false);
    });

    window.addEventListener('resize', () => {
      if (!isMobile()) setExpanded(false);
    });

    const menuDrawer = document.getElementById('Details-menu-drawer-container');
    menuDrawer?.addEventListener('toggle', () => {
      if (menuDrawer.open) setExpanded(false);
    });

    const setActiveLink = (activeLink) => {
      links.forEach((link) => {
        const isActive = link === activeLink;
        link.classList.toggle('pra-policy-toc__link--active', isActive);

        if (isActive) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    };

    let activeFrame = null;
    const syncActiveLink = () => {
      activeFrame = null;

      const currentHeading =
        headings
          .filter((heading) => heading.getBoundingClientRect().top <= window.innerHeight * 0.36)
          .pop() || headings[0];
      const activeLink = linksByHeadingId.get(currentHeading.id);

      if (activeLink) setActiveLink(activeLink);
    };

    const scheduleActiveLinkSync = () => {
      if (activeFrame) return;

      activeFrame = requestAnimationFrame(syncActiveLink);
    };

    window.addEventListener('scroll', scheduleActiveLinkSync, { passive: true });
    window.addEventListener('resize', scheduleActiveLinkSync);

    body.prepend(scrim, aside);
    syncActiveLink();
  };

  const initPolicyPages = () => {
    document.querySelectorAll('.shopify-policy__container').forEach(buildPolicyToc);
  };

  const init = () => {
    initDocumentPages();
    initPolicyPages();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
